import { NAVTOGGLE } from '../actions/AuthActions';
import { NAVCLOSE } from '../actions/AuthActions';


const initial = false;

function toggleMenu(state = initial, action) {
    if (action.type === NAVTOGGLE) {   
        return  !state
    }

    if (action.type === NAVCLOSE) {   
        if (window.innerWidth < 500) {
            return true
        }
        return  false
    }
    return state;
}

export {toggleMenu};